import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import { t, translate } from 'react-switch-lang';
import { useSelector } from 'react-redux';
import { brandConfig, getFooterBackgroundColor, getFooterBorderTop, getFooterLinkColor } from '../../configurations/Brands';

function Footer() {
  const { brand, lang } = useSelector((state) => state);
  function disclaimerText() {
    if (brand === 'paysimply') {
      return (
        <div id="trademark-text">
          {brandConfig[brand].sqlName}
          {' '}
          {t('Footer_Provided_By_Text')}
        </div>
      );
    }
    return '';
  }

  function createLinks() {
    const footerLinkList = brandConfig[brand].footerLink;
    const linkArray = [];
    for (let i = 0; i < footerLinkList.length; i += 1) {
      linkArray.push(
        <span key={i}>
          <a
            className="footer-links"
            key={footerLinkList[i][0]}
            id={footerLinkList[i][0]}
            href={t(footerLinkList[i][1])}
            style={{ color: getFooterLinkColor(brand) }}
            target="_blank"
            rel="noreferrer"
          >
            {t(footerLinkList[i][0])}
          </a>
        </span>
      );
    }
    return linkArray;
  }

  return (
    <footer
      id="footer-content"
      aria-label={t('LinkDescription_Footer')}
      role="contentinfo"
      className="footer-style"
      style={
        {
          backgroundColor: getFooterBackgroundColor(brand),
          borderTop: getFooterBorderTop(brand),
        }
      }
    >
      <div id="footer-text">
        {disclaimerText()}
        <span id="footer-links">
          {createLinks()}
          <Link
            id="aria-footer-contact"
            className="footer-links"
            style={{ color: getFooterLinkColor(brand) }}
            to={`/${brand}/${lang}/contactus`}
          >
            {t('General_Contact_Us')}
          </Link>
        </span>
      </div>
    </footer>
  );
}

export default translate(Footer);
